{
    "conco3": 120,
    "conco3mda8": 120,
    "concno2": 200,
    "concpm10": 50,
    "concpm25": 25
}